import React from 'react';
import { useAuth } from '../provider/AuthContext';
import { LogOut, RefreshCcw } from 'lucide-react';
const tradenerLogo = require('../assets/tradener-logo.png');

interface HeaderProps {
  isAutoRefreshActive?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ isAutoRefreshActive = false }) => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
    
    localStorage.clear();
    
    const cleanUrl = (process.env.REACT_APP_AWS_START_URL || "").split('?')[0];
    window.location.href = cleanUrl;
  };

  return (
    <div className="header">
      <div className="header-left">
        <img src={tradenerLogo} alt="WhatsApp Tradener" className="header-logo" />
        <span>WhatsApp Tradener</span>
        {isAutoRefreshActive && (
          <span className="auto-refresh-indicator" title="Auto-refresh ativo">
            <RefreshCcw size={16} color="white" />
          </span>
        )}
      </div>
      <div className="header-right">
          <button
            className="logout-button"
            onClick={handleLogout}
            title="Sair"
          >
            <LogOut size={16} color="white" />
          </button>
      </div>
    </div>
  );
};
